module.exports = __webpack_public_path__ + "img/checkout-error.9ee6d93f.svg";